export type IGetObjectValueByKey = (object: IDCA.IGenericObj, property: string) => any;

export function getObjectValueByKey(object: IDCA.IGenericObj, property: string): any {
  let val;

  function search(data: IDCA.IGenericObj) {
    Object.keys(data).some(key => {
      const item = data[key];
      //  If this item is an object, then recurse into it
      if (typeof item === 'object') {
        search(item);
      } else if (key === property) {
        //  see if this is the key we are looking for
        val = data[key];
        return true;
      }
      return false;
    });
  }

  search(object);
  return val;
}
